import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
const flow = ['Assess', 'Risk', 'Decide', 'Adjust', 'Follow up'];
export function WhySection() {
  return <section className="w-full bg-sand px-5 py-14 sm:px-6 sm:py-20" data-id="element-345" data-mp="18tunanz2urcm">
      <div className="mx-auto max-w-3xl" data-id="element-346" data-mp="18sjjio5mtjli">
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-347" data-mp="1dm4lsse9czqi">The origin</p>
        <h2 className="mt-3 font-serif text-[28px] font-bold leading-[1.12] text-navy sm:text-4xl" data-id="element-348" data-mp="1ikxrhynazmg4">
          Why was Menopause Decision Desk™ created?
        </h2>

        <div className="mt-5 space-y-4 text-[16px] leading-relaxed text-navy/75 sm:text-[17px]" data-id="element-349" data-mp="1rkugy2hiopc8">
          <p data-id="element-350" data-mp="1wjxbgszvfd5y">
            Because the problem isn’t a lack of medical information. Healthcare professionals already have
            access to an enormous amount of it.
          </p>
          <p className="font-serif text-[19px] font-bold italic leading-snug text-navy sm:text-2xl" data-id="element-351" data-mp="3teblgxacpa2r">
            The problem is retrieval and organization at the point of decision.
          </p>
          <p data-id="element-352" data-mp="2ihq2dchyzccq">
            A patient presents with a specific scenario. You need to identify the relevant factors, then
            determine which pathway applies, then decide what needs to be evaluated, considered, adjusted or
            followed. Menopause Decision Desk™ was designed to put that structure in one place.
          </p>
          <p className="text-[15px] text-navy/60" data-id="element-353" data-mp="31f0y4n4e7nnf">
            Not to replace clinical judgment. Not to replace current guidelines. Not to replace
            individualized patient care. But to make the information easier to navigate and organize.
          </p>
        </div>

        <div className="mt-10 rounded-2xl border border-navy/10 bg-white p-5 sm:p-8" data-id="element-354" data-mp="2neq8fnetkf3u">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-355" data-mp="2nh2mvqldc7c5">The 5-minute rule</p>
          <h3 className="mt-2 font-serif text-[22px] font-bold leading-tight text-navy sm:text-[26px]" data-id="element-356" data-mp="1gwb8k51hffnp">
            Find your starting pathway in 5 minutes or less.
          </h3>
          <p className="mt-3 text-[15px] leading-relaxed text-navy/70" data-id="element-357" data-mp="1dhji68rihq8d">
            That’s the core design principle. You don’t need to read 200 pages before your next
            consultation — you start with the clinical scenario, then navigate:
          </p>

          <ol className="mt-6 space-y-2" data-id="element-358" data-mp="18glz7tyogs5t">
            {flow.map((step, i) => <li key={step} data-id="element-359" data-mp="upqki11hzgub" data-mpi={i}>
                <div className="flex items-center gap-3 rounded-xl bg-sand px-4 py-3" data-id="element-360" data-mp="upgw2hw3phqq">
                  <span className="font-serif text-[13px] font-bold text-gold" data-id="element-361" data-mp="zi0hg1115h63">{String(i + 1).padStart(2, '0')}</span>
                  <span className="text-[14.5px] font-bold uppercase tracking-[0.08em] text-navy" data-id="element-362" data-mp="ktnn18hlc6dp">{step}</span>
                </div>
                {i < flow.length - 1 ? <ArrowDownIcon className="mx-auto my-1 h-3.5 w-3.5 text-navy/25" aria-hidden="true" data-id="element-363" data-mp="bsfnkn3c8zi1" /> : null}
              </li>)}
          </ol>

          <p className="mt-6 text-center font-serif text-[20px] font-bold leading-snug text-navy sm:text-2xl" data-id="element-364" data-mp="3t9tlbnlrxvcz">
            Less searching. <span className="text-gold" data-id="element-365" data-mp="3oc0hv2buvfge">More structure.</span>
          </p>
        </div>

        <SectionCta headline="Get the structure that answers the question in front of you." label="Get the Decision Desk™" data-id="element-366" data-mp="65m3x3dl75i0" />
      </div>
    </section>;
}